import React, {useState} from "react";
import {Route} from "@/routing/Router";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {useQuery} from "@tanstack/react-query";
import {api} from "@/data/api";
import {toLocalDateString} from "@/utils/DateUtils";
import DayReportPageHeading from "@widgets/reports/dayReport/heading/DayReportPageHeading";
import DayReportDashboard from "@widgets/reports/dayReport/DayReportDashboard";
import ExportDayReportModal from "@widgets/reports/dayReport/export/ExportDayReportModal";
import DayReportPeriodPicker from "@widgets/reports/dayReport/period/DayReportPeriodPicker";
import useReportPeriodParam from "@widgets/reports/dayReport/period/useReportPeriodParam";
import {DAY_REPORT_QUERY_KEY} from "@widgets/reports/dayReport/DayReportUtils";

type Props = {
    route: Route,
};

const DayReportOverview = ({route}: Props) => {
    const {dashboardLocation} = useRestaurant();
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [period, setPeriod] = useReportPeriodParam();
    const from: string = toLocalDateString(period.from);
    const to: string = toLocalDateString(period.to);
    const {data, isFetching, isError} = useQuery({
        queryKey: [DAY_REPORT_QUERY_KEY, dashboardLocation.id, from, to],
        queryFn: () => api.dayReport.getDayReport(dashboardLocation.id, from, to),
    });

    return (
        <>
            <DayReportPageHeading
                route={route}
                period={period}
                setShowDatePicker={setShowDatePicker}
                setShowExportModal={setShowExportModal}
                dataLoading={isFetching}
            />

            <div className={"mt-6 md:mt-12"}>
                <DayReportDashboard
                    dayReport={data}
                    isFetching={isFetching}
                    isError={isError}
                    setShowExportModal={setShowExportModal}
                />
            </div>

            <DayReportPeriodPicker
                showDatePicker={showDatePicker}
                setShowDatePicker={setShowDatePicker}
                period={period}
                setPeriod={setPeriod}
            />

            <ExportDayReportModal
                dayReport={data}
                show={showExportModal}
                setShow={setShowExportModal}
            />
        </>
    );
};

export default DayReportOverview;